import LegalPage from "../../components/LegalPage";
import content from "../../legal/privacyContent";

const Privacy = () => <LegalPage title="Privacy Policy" content={content} />;

export default Privacy;
